export default {"src":"/_next/static/media/QLD-card-number-back.92be4106.svg","height":142,"width":222,"blurWidth":0,"blurHeight":0};